import React, { useMemo } from 'react';

/** انتخاب ترکیب (رنگ/سایز) — value: {key: value} */
export default function VariantSelector({ variants, value, onChange }) {
  const keys = useMemo(() => {
    const ks = [];
    (variants || []).forEach(v => Object.keys(v.attrs || {}).forEach(k => { if (!ks.includes(k)) ks.push(k); }));
    return ks;
  }, [variants]);
  if (!variants || !variants.length || !keys.length) return null;
  const opts = k => {
    const s = new Set();
    variants.forEach(v => { if (v.attrs && v.attrs[k] !== undefined && v.attrs[k] !== '') s.add(String(v.attrs[k])); });
    return [...s];
  };
  // موجودی ترکیبِ دقیقاً منطبق با انتخاب فعلی
  const exact = variants.find(v => keys.every(k => String(v.attrs?.[k] || '') === String(value?.[k] || '')) && keys.some(k => String(value?.[k] || '') !== ''));
  const set = (k, val) => onChange({ ...(value || {}), [k]: val });
  return (
    <div className="mt-5">
      {keys.map(k => (
        <div key={k} className="mb-3">
          <div className="mb-1.5 text-sm font-bold">{k}: <span className="font-normal text-muted-foreground">{value?.[k] || '—'}</span></div>
          <div className="flex flex-wrap gap-2">
            {opts(k).map(o => {
              const active = String(value?.[k] || '') === o;
              // آیا با این انتخاب (بقیه ثابت) ترکیبی موجود است؟
              const probe = { ...(value || {}), [k]: o };
              const m = variants.find(v => keys.every(kk => String(v.attrs?.[kk] || '') === String(probe[kk] || '')));
              const soldOut = m && Number(m.stock) <= 0;
              return (
                <button key={o} type="button" disabled={soldOut} onClick={() => set(k, o)}
                  style={{
                    padding: '7px 14px', borderRadius: 10, fontSize: 13, fontWeight: active ? 800 : 500, cursor: soldOut ? 'not-allowed' : 'pointer',
                    border: active ? '2px solid var(--primary)' : '1px solid var(--border)',
                    background: active ? 'color-mix(in srgb, var(--primary) 10%, transparent)' : 'var(--card)',
                    color: soldOut ? 'var(--muted-foreground)' : 'var(--fg)', opacity: soldOut ? 0.5 : 1,
                    textDecoration: soldOut ? 'line-through' : 'none',
                  }}>
                  {o}
                </button>
              );
            })}
          </div>
        </div>
      ))}
      {exact && (
        <div className="text-[13px]" style={{ color: Number(exact.stock) > 0 ? 'var(--success, #15803d)' : 'var(--destructive)' }}>
          {Number(exact.stock) > 0 ? `موجودی این ترکیب: ${Number(exact.stock).toLocaleString('fa-IR')} عدد` : 'این ترکیب ناموجود است'}
          {Number(exact.price_delta) !== 0 && (
            <span> — {Number(exact.price_delta) > 0 ? '+' : ''}{Number(exact.price_delta).toLocaleString('fa-IR')} تومان</span>
          )}
        </div>
      )}
    </div>
  );
}
